(function () {
  const STORAGE_KEY = 'blancspace_wishlist';

  function getWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(data) ? data.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    const cleanWishlist = [...new Set(wishlist.map(String))];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cleanWishlist));
  }

  function isSaved(productId) {
    return getWishlist().includes(String(productId));
  }

  function toggleProduct(productId) {
    productId = String(productId);
    let wishlist = getWishlist();

    if (wishlist.includes(productId)) {
      wishlist = wishlist.filter(function (id) {
        return id !== productId;
      });
    } else {
      wishlist.push(productId);
    }

    saveWishlist(wishlist);
    return wishlist.includes(productId);
  }

  /* -------------------------
     UPDATE HEADER COUNT
  ------------------------- */

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('.wishlist-count').forEach(function (element) {
      element.textContent = count;
    });

    document.querySelectorAll('.wishlist-count-bubble').forEach(function (bubble) {
      bubble.style.display = count > 0 ? 'block' : 'none';
    });
  }

  /* -------------------------
     UPDATE ALL HEARTS
  ------------------------- */

  function updateAllHearts() {
    document.querySelectorAll('.blancspace-wishlist-button').forEach(function (button) {
      const productId = String(button.dataset.productId);
      const saved = isSaved(productId);
      const heart = button.querySelector('.blancspace-wishlist-heart');

      if (heart) {
        heart.textContent = saved ? '❤' : '♡';
      }

      button.classList.toggle('is-wishlisted', saved);
      button.title = saved ? 'Remove from Wishlist' : 'Add to Wishlist';

      button.setAttribute(
        'aria-label',
        saved ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });

    document.querySelectorAll('.blancspace-card-wishlist').forEach(function (button) {
      const productId = String(button.dataset.productId);
      const saved = isSaved(productId);
      const heart = button.querySelector('.blancspace-card-wishlist-heart');

      if (heart) {
        heart.textContent = saved ? '❤' : '♡';
      }

      button.classList.toggle('is-wishlisted', saved);
      button.title = saved ? 'Remove from Wishlist' : 'Add to Wishlist';

      button.setAttribute(
        'aria-label',
        saved ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });
  }

  /* -------------------------
     PRODUCT PAGE HEART
  ------------------------- */

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.blancspace-wishlist-button');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleProduct(button.dataset.productId);

    updateAllHearts();
    updateWishlistCount();
  });

  /* -------------------------
     PRODUCT CARD HEART
     Capture phase prevents Dawn
     product link from opening
  ------------------------- */

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.blancspace-card-wishlist');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      toggleProduct(button.dataset.productId);

      updateAllHearts();
      updateWishlistCount();
    },
    true
  );

  /* -------------------------
     WISHLIST PAGE
  ------------------------- */

  async function renderWishlistPage() {
    const grid = document.getElementById('blancspace-wishlist-grid');
    const emptyMessage = document.getElementById('blancspace-wishlist-empty');

    if (!grid) return;

    grid.innerHTML = '';

    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      if (emptyMessage) {
        emptyMessage.style.display = 'block';
      }
      return;
    }

    if (emptyMessage) {
      emptyMessage.style.display = 'none';
    }

    try {
      /* Fetch catalogue only once */
      const response = await fetch('/products.json?limit=250');

      if (!response.ok) {
        throw new Error('Unable to load products');
      }

      const data = await response.json();

      wishlist.forEach(function (productId) {
        const product = data.products.find(function (item) {
          return String(item.id) === String(productId);
        });

        if (!product) return;

        const variant = product.variants[0];
        const image =
          product.images && product.images.length
            ? product.images[0].src
            : '';

        const card = document.createElement('div');
        card.className = 'blancspace-wishlist-card';
        card.dataset.productId = String(product.id);

        card.innerHTML = `
          <a
            href="/products/${product.handle}"
            class="blancspace-wishlist-image-link"
          >
            ${
              image
                ? `<img
                    src="${image}"
                    alt="${escapeHtml(product.title)}"
                    class="blancspace-wishlist-image"
                    loading="lazy"
                  >`
                : ''
            }
          </a>

          <div class="blancspace-wishlist-info">

            <a
              href="/products/${product.handle}"
              class="blancspace-wishlist-product-title"
            >
              ${escapeHtml(product.title)}
            </a>

            <div class="blancspace-wishlist-price">
              ₹${Number(variant.price).toLocaleString('en-IN')}
            </div>

            <div class="blancspace-wishlist-actions">

              <a
                href="/products/${product.handle}"
                class="blancspace-wishlist-select"
              >
                Select Options
              </a>

              <button
                type="button"
                class="blancspace-wishlist-remove"
                data-product-id="${product.id}"
                aria-label="Remove from wishlist"
                title="Remove from Wishlist"
              >
              
              </button>

            </div>

          </div>
        `;

        grid.appendChild(card);
      });

      /* If saved IDs no longer correspond to products */
      if (!grid.children.length && emptyMessage) {
        emptyMessage.style.display = 'block';
      }
    } catch (error) {
      console.error('BlancSpace wishlist error:', error);
    }
  }

  /* -------------------------
     REMOVE FROM WISHLIST PAGE
  ------------------------- */

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.blancspace-wishlist-remove');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const productId = String(button.dataset.productId);

    let wishlist = getWishlist();

    wishlist = wishlist.filter(function (id) {
      return id !== productId;
    });

    saveWishlist(wishlist);

    const card = button.closest('.blancspace-wishlist-card');

    if (card) {
      card.remove();
    }

    updateAllHearts();
    updateWishlistCount();

    const grid = document.getElementById('blancspace-wishlist-grid');
    const emptyMessage = document.getElementById('blancspace-wishlist-empty');

    if (grid && grid.children.length === 0 && emptyMessage) {
      emptyMessage.style.display = 'block';
    }
  });

  /* -------------------------
     BASIC HTML ESCAPING
  ------------------------- */

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* -------------------------
     INITIAL LOAD
  ------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    updateAllHearts();
    updateWishlistCount();
    renderWishlistPage();
  });
})();